import React from "react";
import { store as reduxStore } from "../../redux/store";
import {myGlobals} from '../../Utils';

//create components using React.lazy
const DefaultTheme = React.lazy(() => import('./defaultTheme'));
const Default1Theme = React.lazy(() => import('./default1Theme'));
const AdobeTheme = React.lazy(() => import('./adobeTheme'));
const TrifectaTheme = React.lazy(() => import('./trifectaTheme'));
const ModernUXTheme= React.lazy( () => import('./modernUxTheme'));
const ZollCustomTheme= React.lazy( () => import('./zollCustomTheme'));
//create a parent component that will load the components conditionally using React.Suspense
const ThemeSelector = ({ children }) => {
  const CHOSEN_THEME = reduxStore.getState().styleNames.RONE_CSS;
  myGlobals.currentTheme = CHOSEN_THEME;
  console.log('Using Theme: ', CHOSEN_THEME)
  return (
    <>
      <React.Suspense fallback={<></>}>
        {(CHOSEN_THEME === "default.css") && <DefaultTheme />}
        {(CHOSEN_THEME === "default1.css") && <Default1Theme />}
        {(CHOSEN_THEME === "adobe.css") && <AdobeTheme />}
        {(CHOSEN_THEME === "trifectaTheme.css") && <TrifectaTheme />}
        {(CHOSEN_THEME === "modernUX.css") && <ModernUXTheme />}
        {(CHOSEN_THEME === "zollCustomTheme.css") && <ZollCustomTheme />}
      </React.Suspense>
      {children}
    </>
  )
}

export default ThemeSelector;